export const parametrage = {
  Categories: {
    fiche: {
      title: {
        edit_title: 'Fiche de la catégorie',
        view_title: 'Fiche de la catégorie {{code}}',
        new_title: "Création d'une nouvelle catégorie",
        operations: 'Liste des codes opérations liés',
        flows: 'Liste des flux bancaires liés',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        new: 'Nouveau',
        create: 'Créer',
        movement: 'Mise à jour des Mouvements',
      },
      champ_titles: {
        code: 'Code',
        direction: 'Sens',
        libelle: 'Libellé',
        default_category: 'Categorie Défaut',
      },
      modal: {
        update:
          'Voulez-vous appliquer la catégorie aux mouvements des codes opérations sélectionnés',
        title: 'Sélection des codes opérations',
        flow_title: 'Sélection des codes flux',
        filters: {
          type: 'Type',
        },
      },
    },
    table: {
      header: {
        title: 'Liste des catégories',
        new_category: 'Nouveau',
      },
      columns: {
        code: 'Code',
        libelle: 'Libellé',
        date: 'Date de modification',
        default_category: 'Categorie Défaut',
      },
    },
  },
  GlobalUser: {
    table: {
      error_mes: {
        text: 'Le nombre de users actifs autorisés est atteint.',
      },
      header: {
        title: 'Liste des utilisateurs groupes',
        synthese: 'Synthèse droit utilisateur',
        new: 'Nouveau',
      },
      columns: {
        login: 'Login',
        first_name: 'Prénom',
        last_name: 'Nom',
        email: 'Email',
        mobile_number: 'N° mobile',
        date: 'Date de modification',
        interrupteur: 'TOTP',
        totp: 'Type TOTP',
        is_locked: 'Bloqué',
      },
    },
    fiche: {
      title: {
        edit_title: 'Fiche utilisateur {{name}}',
        add_title: "Création d'un nouvel utilisateur",
        message_confirm_initialise:
          'Voulez-vous réinitialiser les paramètres TOTP de ce user',
      },
      champ_titles: {
        etat: 'Etat',
        email: 'Email',
        login: 'Login',
        firstname: 'Prénom',
        lastname: 'Nom',
        langue: 'Langue',
        tel: 'Téléphone',
        fax: 'Fax',
        mobile: 'Mobile',
        recepemail: 'Mail de reception',
      },
      group_user: {
        title: 'Groupes utilisateurs',
        name: 'Nom',
        code: 'Code',
        action: 'Action',
      },
      alert: {
        pdf_file: 'Veuillez importer un file en format pdf',
        file_import: 'Importation file en format pdf obligatoire',
      },
      appareil_connected: {
        title: 'Appareils connectés',
        name: 'Nom',
        date1: 'Date création',
        date2: 'Dérniere connexion',
        action: 'Action',
      },
      document: {
        title: 'Documents',
        date: 'Date',
        doc_name: 'Nom document',
        doc_type: 'Type document',
        state: 'Etat',
        date1: 'Date début',
        date2: 'Date fin',
        action: 'Action',
        confirm_delete: "Ce document est lié à plusieurs messages envoyés aux banques. Etes-vous sûr de vouloir supprimer le document"
      },
      errors: {
        phoneNumber: 'Le numéro de téléphone ne doit contenir que des chiffres',
        phoneMinLen:
          'Le numéro de téléphone doit comporter au moins 10 chiffres',
        phoneMaxLen:
          'Le numéro de téléphone doit comporter au maximum 15 chiffres',
        faxError: 'Fax invalide',
        mobilError: 'Mobile invalide',
      },
    },
  },
  GroupAdmin: {
    fiche: {
      title: {
        edit_title: "Fiche du groupe d'administrateurs {{name}}",
        view_title: "Fiche du groupe d'administrateurs {{name}}",
        new_title: "Création d'un nouveau groupe d'administrateurs",
        member: 'Membres',
        autorisation: 'Autorisations',
        headerTitle: 'Fiche groupe administrateurs',
        createheaderTitle: "Création d'un nouveau groupe",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        new: 'Nouveau',
        add: 'Ajouter',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        state: 'Etat',
        prenom: 'Prénom',
        login: 'Login',
        flux: 'Flux',
        releve: 'Relevés',
        referentiel: 'Référentiel',
        settings: 'Paramétrage',
        treatment: 'Traitements',
        accounting: 'Comptabilité',
        accounting_export: 'Export comptable',
        smart_tags: 'Smart Tags',
      },
    },
    table: {
      header: {
        title: "Liste des groupes d'administrateurs",
        new_groupadmin: 'Nouveau',
      },
      columns: {
        nom: 'Nom',
        date: 'Date de modification',
        state: 'Etat',
        code: 'Code',
      },
    },
  },
  Label: {
    fiche: {
      title: {
        edit_title: 'Fiche du label {{label}}',
        view_title: 'Fiche du label {{label}}',
        new_title: "Création d'un nouveau label",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
      },
      champ_titles: {
        libelle: 'Libellé personnalisé',
        libelle_origine: "Libellé d'origine",
        rubrique_value: 'Valeur rubrique',
        sheet: 'Fiche',
        rubrique: 'Rubrique',
        color: 'Couleur',
        add_fiche: 'Ajouter Fiche',
        add_rubrique: 'Ajouter Rubrique',
        add_color: 'Ajouter Couleur',
      },
      error: {
        err_message: 'Erreur',
        field_message: 'Champ requis',
      },
    },
    table: {
      header: {
        title: 'Liste des labels',
        new_label: 'Nouveau',
      },
      columns: {
        label: 'Label',
        date: 'Date de modification',
        rubrique_value: 'Valeur rubrique',
        sheet: 'Fiche',
      },
    },
  },
  Perimetre: {
    fiche: {
      title: {
        edit_title: 'Fiche du périmètre {{name}}',
        view_title: 'Fiche du périmètre {{name}}',
        new_title: "Création d'un nouveau périmètre",
        member: 'Membre',
        autorisation: 'Autorisation',
        entities_list: 'Liste des entités',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        new: 'Nouveau',
        create: 'Créer',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        state: 'Etat',
        prenom: 'Prénom',
        login: 'Login',
        flux: 'Flux',
        releve: 'Relevés',
        referentiel: 'Référentiel',
        settings: 'Paramétrage',
        treatment: 'Traitements',
        accounting: 'Comptabilité',
        accounting_export: 'Export comptable',
      },
    },
    table: {
      header: {
        title: 'Liste des périmètres',
        new_perimetre: 'Nouveau',
      },
      columns: {
        label: 'Libellé',
        date: 'Date de modification',
        state: 'Etat',
        code: 'Code',
        first_name: 'Prénom',
      },
    },
  },
  Banques: {
    fiche: {
      title: {
        edit_title: 'Fiche de la banque {{name}}',
        view_title: 'Fiche de la banque',
        new_title: "Création d'une nouvelle banque",
        cut_off: 'Cut-Off',
        added_cutoff_title: "Ajout d'un Cut- off",
        creation_title_banque: "Creation d'une nouvelle banque",
        edit_tile_banque: 'Fiche du compte {{name}}',
        tarif: 'Tarif',
        tarif_modal: 'Sélectionner un tarif',
        add_tarif_title: " Ajout d'un Tarif",
        category: 'Catégorie',
        code: 'Code',
        placeholder_category: '- Catégorie -',
        message_category: 'Catégorie déjà existé',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
        add: 'Ajouter',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        flux: 'Flux',
        hour: 'Heure',
        exec_condition: 'Condition Exécution',
        mounthly_fees: 'Tarif mensuel',
        annual_fees: 'Tarif annuel',
        month_annual_fees: 'Mois de frais annuel',
        movement_commission: 'Commission de mouvement',
        bank_fees_type: 'Type Frais bancaire',
        type: 'Type',
      },
      columns: {
        condition: 'Condition Exécution',
        hour: 'Heure',
        flow: 'Flux',
        code: 'Code',
        label: 'Libellé',
        tarif: 'Tarif',
        mois: 'Mois',
        currency: 'Devise',
      },
      columns_contact: {
        title: 'Contacts',
        name: 'Nom',
        last_name: 'Prénom',
        phone: 'Téléphone',
        mail: 'Email',
        adress: 'Adresse',
        agence: 'Agence',
        flux: 'Flux',
        pouvoir: 'Pouvoir',
        agenceName: 'Nom Agence',
      },
    },
    infos_personalise: {
      title: 'Informations personnelles ',
      birth_date: 'Date de naissance',
      birth_country: 'Pays de naissance',
      birth_place: 'Lieu de naissance',
      nationality: 'Nationalité',
      num_cin: 'Numéro CIN',
      date_validate_cin: 'Date validation CIN',
    },
    table: {
      header: {
        title: 'Liste des banques',
        new_bank: 'Nouveau',
        el_authorized: '(Nombre autorisé : {{nombre}})',
        message_ele_atteint:
          'Le nombre maximum de banques autorisé est atteint',
        el_authorized_treso:
          '(Nombre de comptes gérés en trésorerie: {{nombre}})',
        message_ele_treso:
          ' Le nombre maximum de comptes gérés en trésorerie est atteint',
      },
      columns: {
        name: 'Nom',
        code: 'Code',
      },
    },
    contact: {
      title: "Création d'un nouvel contact",
      title_edit: "Fiche d'un contact",
      last_name: 'Prénom',
      name: 'Nom',
      name_agence: 'Nom agence',
      title_civil: 'Civilité',
      mail: 'Email',
      phone: 'Téléphone',
      fax: 'Fax',
      mobile: 'Mobile',
      contact_agence: 'Contact agence',
      contact_Flux: 'Contact Flux',
      contact_pouvoir: 'Contact Pouvoir ',
      title_adress: 'Adresse',
      type_aress: 'Type adresse',
      department: 'Service',
      Sub_Departement: 'Sous-Service',
      street_name: 'Nom de la voie',
      build_number: ' Numéro de voie',
      floor: 'Etage',
      post_box: ' Boîte postale',
      room: 'Salle',
      town_location_name: 'Lieu-Dit',
      post_code: 'Code postal',
      town_name: 'Ville',
      country: 'Pays',
      districtName: ' District',
      districk_name: 'Nom du district',
      country_Sub_Division: 'Région',
      civility: 'Civilité',
      error_champ_obligatoire:
        'Veuillez compléter les champs obligatoires : Nom, Prénom, Civilité, Pays, et Ville .',
      error_champ_ville_obligatoire: 'Nom de la ville obligatoire',
    },
  },
  Filiales: {
    fiche: {
      title: {
        edit_title: 'Fiche de la filiale {{code}}',
        new_title: "Création d'une nouvelle entité",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        state: 'Etat',
      },
    },
    table: {
      header: {
        title: 'Liste des entités',
        new_filiale: 'Nouveau',
      },
      columns: {
        code: 'Code',
        state: 'Etat',
        libelle: 'Libellé',
        date: 'Date de modification',
      },
    },
  },
  smarttag: {
    fiche: {
      title: {
        edit_title: "Modification d'un smart tag",
        view_title: 'Fiche du smart tag {{code}}',
        new_title: 'Fiche du smart tag',
        add_title: "Creation d'un nouveau smart tag",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
        add: 'Ajouter',
      },
      champ_titles: {
        champcode: 'Code',
        color: 'Couleur',
      },
    },
    table: {
      header: {
        title: 'Liste des SmartTags',
        new_smart: 'Nouveau',
      },
      columns: {
        code: 'Code',
      },
    },
  },
  groupe_tresorerie: {
    fiche: {
      title: {
        edit_title: 'Fiche du groupe trésorerie {{name}}',
        view_title: 'Fiche du groupe trésorerie {{name}}',
        new_title: "Creation d'un nouveau groupe trésorerie",
        companies_member_list: 'Liste des sociétés membres',
        member_list: 'Membre',
      },
      modal: {
        user_list: "Sélection d'utilisateurs",
        company_list: 'Sélection de sociétés',
        account_list: 'Sélection de comptes',
        third_party_group_list: 'Sélection de groupe de tiers',
      },
    },
    table: {
      title: 'Liste des groupes de trésoriers',
    },
  },
  account_statement: {
    table: {
      select_cat: 'Sélection des codes opérations',
      category_code: 'Code Catégorie',
      title: 'Administration des relevés de compte',
      etat: '- Etat -',
      confirme_update_row: 'Voulez-vous valider votre modification',
      search_txt:
        'Rechercher un compte par code, nom, numéro de compte, code société, nom société...',
      headerTitle: {
        etat: 'Etat',
        code: 'Code',
        name: 'Nom',
        iban: 'IBAN',
        company: 'Société',
        solde: 'Solde',
        devise: 'Devise',
        date_solde: 'Date de solde',
        nbMvt: 'Nb mouvements',
      },
    },
    details: {
      title: 'Liste des journées du compte',
      reintegration: 'Réintégration des relevés',
      delete_temp: 'Supprimer les relevés temporaires',
      purge: 'Purge complète des relevés du compte',
      all: 'Tout',
      production: 'Production',
      temp: 'Temporaire',
      new_day: 'Nouvelle Journée',
      delete_day: 'Supprimer la journée',
      headerTitle: {
        date_debut: 'Date de début',
        solde_debut: 'Solde de début',
        date_fin: 'Date de fin',
        solde_fin: 'Solde de fin',
        prod: 'Prod',
        last_releve: 'Dernier relevé intégré',
        statements: 'Nb mouvements',
        currency: 'Devise',
        balance_diff: 'Différence solde',
        mvt_total: 'Somme des opérations',
        update_timestamp: 'Date Modification',
        create_timestamp: 'Date Création',
      },
      confirmNewday: {
        title: 'Fiche relevé',
        txt: 'Vous ne pouvez créer des journées que avant ou après les relevés déjà en production Que désirez-vous créer ?',
        before: 'Avant le',
        after: 'Après le',
        cancel: 'Annuler',
      },
    },

    new_day_time: {
      alert_date: 'La date initiale doit être inférieure à la date finale',
      valider: 'Valider',
      cancel: 'Annuler',
      solde_initial: 'Solde initial',
      date_initial: 'Date initiale',
      solde_final: 'Solde finale',
      date_final: 'Date finale',
      remove_day_time: 'Etes-vous sûr de vouloir supprimer',
      add_operation: "Ajouter une ligne d'opération",
      purge_account:
        'Etes-vous sûr de vouloir purger les relevés de compte de production de ce compte',
      remove_temp:
        'Etes-vous sûr de vouloir purger les relevés de compte temporaire de ce compte',
      headerTitle: {
        libeller: 'Libellé',
        operation_date: 'Date Opération',
        date_valeur: 'Date Valeur',
        operation_code: 'Code Opération',
        num_ecriture: 'N Ecriture',
        exo: 'Exo',
        montant: 'Montant',
      },
      modalCode: {
        title: 'Sélection des codes opérations',
        select: 'Sélectionner',
        cancel: 'Annuler',
        headerTitle: {
          code: 'Code',
          name: 'Nom',
          sens: 'Sens',
        },
      },
    },
    modal_add_balance: {
      title: 'Initialisation balance',
      date_initiale: 'Date initiale',
      solde_initial_balance: 'Solde initiale',
    },
  },

  rules_account_statement: {
    table: {
      title: 'Liste des Règles relevés',
      columns: {
        code: 'Code',
        name: 'Nom',
        flow: 'Flux',
        category: 'Catégorie',
        type: 'Type',
        update_timestamp: 'Date de modification',
        state: 'Etat',
      },
    },
    fiche: {
      new_title: 'Fiche de la règle relevé',
      edit_title: ' Fiche de la règle relevé - {{name}}',
      company_liste: 'Liste des sociétés',
      bank_title: 'Liste des banques',
      account_groupe_title: 'Liste des groupes de comptes',

      card: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        category: 'Catégorie',
        type: 'Type',
        selection: 'Sélection',
        comment: 'Déscription',
        language: 'Langue',
      },
      critere: {
        title: 'Critères recherche ',
        category: 'Catégorie',
        label: 'Libellé',
        fourchette_amount: 'Fourchette montant',
        min: 'Min',
        max: 'Max',
        reference: 'IDBénéficiaire',
        rum: 'RUM',
        inclus_ref: 'Inclus de la liste',
        exclus_ref: 'Exclus de la liste',
        yes: 'Oui',
        no: 'Non',
        inclus: 'Inclus',
        exclus: 'Exclus',
        integrate: 'Intégrer',
        columns_reference: {
          reference: 'IDBénéficiaire',
          description: 'Description',
          date: 'Date',
          user: 'User',
        },
        modal_reference: {
          add_ref: "Ajout d'une Référence",
          reference: 'Référence',
          description: 'Description',
        },
        columns_rum: {
          rum: 'RUM',
          description: 'Description',
          date: 'Date',
          user: 'User',
        },
        modal_rum: {
          add_rum: 'Ajout RUM',
          rum: 'RUM',
          description: 'Description',
        },
      },
      ventilation: {
        title: 'Ventilation',
        categorie_ventilation: 'Catégorie de ventilation',
      },
      columns: {
        code: 'Code',
        name: 'Nom',
      },
    },
  },
  custom_report: {
    fiche: {
      comment: "Commentaire",
      date: "Date",

    },
    table: {
      title: 'Liste des commentaires',
      create_comment: 'Création  de commentaire',
      update_comment: 'Modification  de commentaire',

      columns: {
        comment: 'Commentaire',
        user: 'Utilisateur',
        date: 'Date',
        update_timestamp: 'Date de modification',

      },
    },
  },
  document_type: {
    fiche: {
      title: {
        new_title: "Création d'un nouveau type de document",
        edit_title: 'Fiche du type de document {{name}}',
      },
      champ_titles: {
        name: 'Nom',
        code: 'Code',

        table_type: 'Type de table',
      },

      table_type: 'Table',
    },
    table: {
      title: 'Liste des types de documents',
      columns: {
        code: 'Code type',
        name: 'Nom type',
        table_type: 'Type table',
      },
    },
  },
  group_widget: {
    fiche: {
      title: {
        edit_title: 'Fiche du widget group  {{code}}',
        view_title: 'Fiche du widget group',
        new_title: 'Fiche du smart tag',
        add_title: "Creation d'un nouveau widget group",
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        user: 'Sélection utilisateurs',
      },
    },
    table: {
      header: {
        title: 'Liste des Widgets Groupes',
      },
    },
    table_user: {
      title: 'Liste des utilisateurs',
      champ_titles: {
        champlogin: 'Login',
        champname: 'Nom',
      },
    },
    table_widget: {
      title: 'Liste des widgets',
      champ_titles: {
        champcode: 'Code',
        champname: 'Nom',
      },
    },
    modal_widget: {
      title: 'Liste des utilisateurs',
      champ_titles: {
        champlogin: 'Login',
        champname: 'Nom',
      },
    },
  },
  settings: {
    fiche: {
      title: {
        foureyes_title: 'Paramétrage4 Yeux',
        foureyes_description:
          'Paramétrage du module 4 Yeux (Tables, Champs, Historisation)',
        group_setting_title: 'Paramétrage groupe',
        group_description: 'Paramétrage groupe',
        mobile_setting_title: 'Liste des comptes membres',
        mobile_description: 'Paramétrage des authentifications groupe',
        signature_setting_title: 'Paramétrage Signature',
        signature_description: 'Paramétrage de la signature EBICS',
      },
      champ_titles_fouryeux: {
        table_name: 'Nom table',
      },
      champ_titles_group: {
        logo: 'Logo',
        session: 'Maintenir session active',
        currency: 'Devise',
        code_swift: 'Code swift',
        ai_choice: 'Choix AI',
        number_ai_calls: 'Appel AI effectué',
        paid_ai_calls: 'Appel AI autorisé',
        title_card: 'Paramétrage AI',
      },
      champ_titles_mobile: {
        mobile: 'Mobile',
        authentication_token_validity: "Validité token d'authentification",
        signature_token_validity: 'Validité token de signature',
        webservice_restAPI_key: 'Clé API Webservice REST',
        state: 'Etat',
        code: 'Code',
        clientid: 'ClientID',
        modified_date: 'Date de modification',
      },
      champ_titles_iban: {
        ibanCom: 'IBAN.COM',
        state: 'Etat',
        email: 'Adresse',
        client: 'API Key',
      },
      champ_titles_security: {
        title_button_active_transaction: 'Activer Transaction',
        local_authentication: 'Authentification locale',
        state: 'Etat',
        sisid: 'SIS ID',
        complex: 'Complexe',
        minimum_length: 'Longueur minimale',
        minimum_length_description: 'Longueur minimale  du mot de passe',
        validity_period: 'Durée de validité',
        validity_period_description: 'Durée de validité du mot de passe',
        stored_number: 'Nombre mémorisés',
        stored_number_description: 'Nombre de mots de passe mémorisés',
        test_number: "Nombre d'essais (0-pas de blocage)",
        test_number_description: "Nombre d'essais de mots de passe avant blocage",
        linkedin_authentication: 'Authentification linkedin',
        openidconnect: 'Authentification OpenIDConnect',
        identifier: 'Identifiant fourni dans la console développeur de LinkedIn',
        secret_code: 'Code secret fourni dans la console développeur de LinkedIn',
        urlauth_description: 'URLAuth fourni dans la console développeur LinkedIn',
        urltoken_description: 'URLToken fourni dans la console développeur LinkedIn',
        urlconfig_Allowed_Domain: 'Liste des noms de domaines autorisés (séparés par des points-virgules)',
        Label_urlconfig_Allowed_Domain: 'Noms de domaines autorisés',
        urlconfig_description: 'URL de configuration OpenIDConnect',
        attributupn: "Attribut contenat l'UPN",
        number_requested_batch: 'Nombre de mots de passe mémorisés',
        last_date: 'Date dernière transaction',
        docusign: 'Signature électronique document',
        legisway: 'Legisway',
        trustpair: 'Trustpair',
      },
      champ_titles_signature: {
        signature_mode: 'Mode de signature',
      },

      modalkeysapi: {
        title: "Ajout d'une clé API",
        state: 'Etat',
        code: 'Code',
        clientid: 'ClientID',
        clientid_description: "Identifiant de l'application cliente",
        clientsecret: 'ClientSecret',
        clientsecret_description: 'Code secret fourni dans la console ADFS',
        attribut_upn: 'Attribut UPN',
        scope: 'Scope',
        third: 'Tiers',
        treasury: 'Trésorerie',
        import_file: 'Import de fichiers',
        number_requested_batch: 'Nb demandes par batch',
        service: 'Service',
      },
      doc_sign: {
        integration_key: "Clé d'intégration",
        secret_key: 'Clé secrète',
        userId: 'ID utilisateur',
        private_key: 'Clé privée',
        integration_key_desc:
          "Clé d'intégration fournie par la plateforme de signature électronique",
        secret_key_desc:
          'Clé secrète fournie par la plateforme de signature électronique',
        userId_desc:
          'ID utilisateur fourni par la plateforme de signature électronique',
      },
      trustpair: {
        api_token: "Clé d'API",
        api_env: "Environnement",
        api_type: "Type d'API"
      },
      common_fields: {
        initialisation_date: 'Date initialisation transaction',
        oneshot: 'Execution unique',
        launch_job: 'Lancer Transaction',
      },
    },
    table: {
      title: 'Configuration générale',
      columns: {
        elements: 'éléments',
        foureyes_setup: 'Paramétrage4 Yeux',
        group_setting: 'Paramétrage groupe',
        mobile_setting: 'Paramétrage mobile',
        security_settings: 'Paramétrage sécurité',
        signature: 'Signature',
        search: 'Rechercher une section, un libellé...',
      },
    },
  },
  bank_holiday: {
    title: {
      list_title: 'Liste de dates fériées',
      edit_title: 'Modification de la date fériée {{code}}',
      view_title: 'Fiche de la date fériée {{code}}',
      new_title: "Creation d'une nouvelle date fériée",
    },
    champ_titles: {
      date: 'Date fériée',
      specific_date: 'Jour férié pour une année spécifique',
    },
  },
  quality: {
    title: {
      list_title: 'Liste qualité',
      edit_title: "Modification d'une qualité {{code}}",
      view_title: "Fiche d'une qualité {{code}}",
      new_title: "Creation d'une nouvelle qualité",
      fiche_title: "Fiche d'une qualité",
    },
    champ_document: {
      title: 'Liste des libellés',
      label: 'Libellé',
      langue: 'Langue',
    },
    modal_add_langue: {
      title_add: "Ajout d'un libellé",
      title_edit: "Fiche d'un libellé",
      error_English: 'Langue Anglais déjà ajouté',
      error_Fr: 'Langue Français déjà ajouté',
      error_Lang: 'Langue déjà existe',
    },
  },
  power_ebam: {
    table: {
      title: 'Liste des Descriptions de pouvoirs',
      column: {},
    },
    fiche: {
      title: "Création d'un nouveau pouvoir eBAM",
      title_edit: "Modification d'un pouvoir eBAM {{name}}",
      table_ebam: {
        column: {
          title: 'Codes eBAM',
          code: 'Code',
          num_code: 'Code eBAM',
          description: 'Description',
          title_modal: 'Sélectionner un code eBAM',
          label_lang: 'Langue',
          description_attach: 'Description du code famille',
          descri: '',
        },
      },
    },
  },
  ebam: {
    liste: 'Liste des Code eBAM',
    fiche: {
      title: 'Fiche du Code eBAM',
      type: 'Type',
      codeNum: 'Code Numérique',
      code: 'Code',
      titleRegroupment: 'Regroupement',
      regroupement: 'Regroupement',
      titleLabelListe: 'Liste des Libellés',
    },
  },
}

